import type { SpatialNote } from '@/types';
import { useWorkspaceStore, selectActiveDocument } from '@/store/workspaceStore';
import { updateNoteContentCommand } from '@/features/objects/objectCommands';
import type { ObjectRendererProps } from './types';
import styles from '../ObjectView.module.css';

export const NoteRenderer = ({ object: note }: ObjectRendererProps<SpatialNote>) => {
  const dispatch = useWorkspaceStore((s) => s.dispatch);
  const onChange = (content: string) => {
    const doc = selectActiveDocument(useWorkspaceStore.getState());
    if (!doc) return;
    const command = updateNoteContentCommand(doc, note.id, content);
    if (command) dispatch(command);
  };
  return (
    <>
      <header className={styles.titlebar}>
        <strong>{note.name}</strong>
      </header>
      <div className={styles.body}>
        <textarea
          className={styles.noteText}
          value={note.content}
          placeholder="…"
          readOnly={note.locked}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          onPointerDown={(e) => {
            e.stopPropagation();
          }}
          aria-label={`${note.name} content`}
        />
      </div>
    </>
  );
};
